<span>&copy; {{currentYear}} - PredictScreen</span>